 <template>
    <rkm-overlay>
        <rkm-layout-body title="Assistência social">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.Form.openFile()"
                    color="secondary"
                >
                    Visualizar FAA
                </rkm-button>

                 <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <template
                v-if="paciente"
                v-slot:subtitle
            >

                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ paciente.nome }} <strong>({{ paciente.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ paciente.nome }},
                    </span>
                    <span v-if="paciente.idade">
                        {{ paciente.idade.anos }} anos,
                        {{ paciente.idade.meses }} meses
                        e {{ paciente.idade.dias }} dias,
                    </span>
                    <span>{{ paciente.sexo.descricao }}</span>
                </div>
            </template>

            <rkm-layout-content>
                <Form
                    ref="Form"
                    :id="id"
                    @save="handleSave()"
                    @paciente="handlePaciente"
                />
            </rkm-layout-content>

        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/pronto-atendimento/assistencia-social/Form'

// Enums
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    data: () => ({
        paciente: null,
        enums: { preferenciaNome }
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

                this.redirectToList()
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'pronto-atendimento-assistencia-social-index' })
        },
        handlePaciente(paciente) {

            if (paciente) {
                this.paciente = paciente
            }
        }
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>